var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreyRuble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79297 12.4209H7.5918V14H5.86914V12.4209H4.46777V11.0332H5.86914V10.3018H4.46777V8.91406H5.86914V4.04688H9.67676C10.7751 4.04688 11.6523 4.33398 12.3086 4.9082C12.9648 5.47786 13.293 6.23665 13.293 7.18457C13.293 8.15072 12.9808 8.90951 12.3564 9.46094C11.7321 10.0078 10.8639 10.2881 9.75195 10.3018H7.5918V11.0332H9.79297V12.4209ZM7.5918 8.91406H9.64941C10.2692 8.91406 10.7432 8.77051 11.0713 8.4834C11.3994 8.19629 11.5635 7.7679 11.5635 7.19824C11.5635 6.68783 11.4017 6.27083 11.0781 5.94727C10.7591 5.6237 10.3171 5.45508 9.75195 5.44141H7.5918V8.91406Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyRuble);
export default __webpack_public_path__ + "static/media/grey_ruble.eb6e215f34e9229c38a0aec0a91ad256.svg";
export { ForwardRef as ReactComponent };